<template>
  <div ref="domRef" :class="['base-card-info', marginBottom ? 'mb-0' : '']">
    <div class="info-card-title">
      营业执照信息
    </div>
    <div class="custom-base-info">
      <div class="item" style="z-index: 2;">
        <div class="label">
          营业执照照片
        </div>
        <div class="value h-[0]">
          <div class="business-license-box">
            <img
              :src="baseInfo.companyBusiness?.businessLicensePic"
            >
          </div>
        </div>
      </div>
      <div class="item">
        <div class="label">
          企业名称
        </div>
        <div class="value">
          {{ baseInfo.companyBusiness?.name }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          企业简称
        </div>
        <div class="value">
          {{ baseInfo.companyBusiness?.shortName }}
        </div>
      </div>
      <div class="item">
        <div class="label" />
        <div class="value" />
      </div>
      <div class="item">
        <div class="label">
          法定代表人姓名
        </div>
        <div class="value">
          {{ baseInfo.companyBusiness?.legalName }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          统一社会信用代码
        </div>
        <div class="value">
          {{ baseInfo.companyBusiness?.creditCode }}
        </div>
      </div>
      <div class="item">
        <div class="label" />
        <div class="value" />
      </div>
      <div class="item">
        <div class="label">
          营业执照有效期
        </div>
        <div class="value">
          <span>{{ baseInfo.companyBusiness?.businessLicenseStartDate }}</span>
          <span> ~ </span>
          <span>{{ baseInfo.companyBusiness?.businessLicenseEndDate }}&nbsp;&nbsp;</span>
          <span v-if="['29991231', '2999-12-31'].includes(baseInfo.companyBusiness?.businessLicenseEndDate)">长期</span>
        </div>
      </div>
      <div class="item">
        <div class="label" />
        <div class="value" />
      </div>
      <div class="item">
        <div class="label" />
        <div class="value" />
      </div>
      <div class="item flex-2 mr-4">
        <div class="label">
          注册地址
        </div>
        <div class="value">
          {{ baseInfo.companyBusiness?.address }}
        </div>
      </div>
      <div class="item">
        <div class="label" />
        <div class="value" />
      </div>
      <div class="item flex-2 mr-4">
        <div class="label">
          经营范围
        </div>
        <div class="value">
          {{ baseInfo.companyBusiness?.businessScope }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ICompanyMergeInfo } from '@core/main/types';
import { useElementImgPreview } from '@vue3/components';
import { inject, ref } from 'vue';

defineOptions({ name: 'BusinessLicenseInfo' }); // 账户中心 - 营业执照信息

const domRef = ref<HTMLDivElement>();

useElementImgPreview(domRef);

const baseInfo = inject('baseInfo') as ICompanyMergeInfo;

defineProps({
  marginBottom: {
    type: Boolean,
    default: false,
  },
});
</script>
